import React, { useEffect } from "react";
import "./app.css";
import "./ComponentsWeb/Sub/Substyle.css";
import GoToTop from "./Components/GotoTop";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import { ToastContainer } from "react-toastify";
import NotFoundPage from "./Components/NotFoundPage";
import Dashboard from "./Pages/Dashboard";
import Attribute from "./Pages/Attribute/Attribute";
import Users from "./Pages/Users";
import Categories from "./Pages/Categories/Categories";
import Banners from "./Pages/Banners/Banners";
import Brands from "./Pages/Brands/Brands";
import Setting from "./Pages/Setting/Setting";
import ProductsDetails from "./ComponentsWeb/Sub/ProductsDetails";
import Home from "./ComponentsWeb/Main/Home";
import Reviews from "./Pages/Review/Reviews";
import CheckoutPage from "./ComponentsWeb/Sub/CheckoutPage";
import About from "./ComponentsWeb/Main/About";
import Contact from "./ComponentsWeb/Main/Contact";
import Shop from "./ComponentsWeb/Sub/Shop";
import Checkout from "./ComponentsWeb/Main/Checkout";
import Response from "./ComponentsWeb/Main/Response";
import UserLogin from "./ComponentsWeb/Main/user/UserLogin";
import UserSignup from "./ComponentsWeb/Main/user/UserSignup";
import AddProduct from "./Pages/Products/AddProduct";
import AddUserAddress from "./ComponentsWeb/Main/user/AddUserAddress";
import UserPanel from "./ComponentsWeb/Main/user/UserPanel";
import OrdersList from "./Pages/Orders/OrdersList";
import SocialMediaSetting from "./Pages/SocialMediaSetting";
import ProductsList from "./Pages/Products/ProductsList";
import EmailTemplates from "./Pages/EmailTemplates/EmailTemplates";
import Pages from "./Pages/infoPages/Pages";
import DynamicPages from "./Components/DynamicPages";
import UpdateProduct from "./Pages/Products/UpdateProduct";
import TaxClasses from "./Pages/TaxClasses/TaxClasses";
import ForgotPassword from "./ComponentsWeb/Main/user/forgotpassword/ForgotPassword";
import VerifyOtp from "./ComponentsWeb/Main/user/forgotpassword/VerifyOtp";
import NewPassword from "./ComponentsWeb/Main/user/forgotpassword/NewPassword";
import UserOrderReper from "./Pages/Orders/UserOrderReper";
import UsersCartList from "./Pages/UsersCart/UsersCartList";
import Services from "./Pages/Services/Services";
import Plans from "./Pages/Plans/Plans";
import PlansAdd from "./Pages/Plans/PlansAdd";

import PlanDetails from "./ComponentsWeb/Sub/PlansDetails";
import Funds from "./ComponentsWeb/Main/Funds";
import Gst from "./ComponentsWeb/Main/gst";
import ITR from "./ComponentsWeb/Main/ITR";
import MutualFundcalculator from "./ComponentsWeb/Sub/MutualFundCalculator";
import LoginPop from "./ComponentsWeb/Sub/LoginPop";
import Blog from "./ComponentsWeb/Main/Blog";
import BlogDetails from "./ComponentsWeb/Sub/BlogDetails";
import PaymentResponse from "./ComponentsWeb/Sub/PaymentResponse";
import { useDispatch } from "react-redux";
import { getPages } from "./reducers/frontEndReducer";
import FaqList from "./Pages/FAQ/FaqList";
import Coupons from "./Pages/Coupons/Coupons";
import ServiceHomepage from "./ComponentsWeb/Main/user/forgotpassword/ServiceHomepage";


function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPages());
  },[dispatch])
  return (
    <>
      <Routes>
        {/* web routes start*/}
        <Route path="/" element={<Home />} />
        <Route path="/response/:orderid" element={<Response />} />
        <Route path="/product/:slug" element={<ProductsDetails />} />
        <Route path="/shop/:slug" element={<Shop />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout-new" element={<CheckoutPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/shop" element={<Shop />} />
        {/* <Route path="/login" element={<UserLogin />} /> */}
        <Route path="/signup" element={<UserSignup />} />
        <Route path="/add-user-address" element={<AddUserAddress />} />
        <Route path="/user-dashboard" element={<UserPanel />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/:slug" element={<DynamicPages />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/create-new-password" element={<NewPassword />} />
        {/* web routes end*/}
        <Route path="/admin-login" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/social-media-setting" element={<SocialMediaSetting />} />
        <Route path="/tax-classes" element={<TaxClasses />} />
        <Route path="/attributes" element={<Attribute />} />
        <Route path="/users" element={(localStorage.getItem("username") === "subadmin@gmail.com" ) ? <NotFoundPage /> : <Users />} />
        <Route path="/user-cart" element={<UsersCartList />} />
        <Route path="/orders" element={<OrdersList />} />
        <Route path="/order" element={<UserOrderReper />} />
        <Route path="/orders/:userId" element={<OrdersList />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/services" element={<Services/>} />
        <Route path="/banners" element={<Banners />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/add-product" element={<AddProduct />} />
        <Route path="/product-list" element={<ProductsList />} />
        <Route path="/plans-list" element={<Plans/>} />
        <Route path="/plans-add" element={<PlansAdd/>} />
        <Route path="/product-edit/:slug" element={<UpdateProduct />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/email-templates" element={<EmailTemplates />} />
        {/* <Route path="/login" element={<LoginPage />} /> */}
        <Route path="/login" element={<LoginPop/>} />
        <Route path="/plans-details" element={<PlanDetails/>} />
        <Route path="/faq-list" element={<FaqList/>} />
        <Route path="/coupons" element={<Coupons/>} />
        <Route path="/funds" element={<Funds />} />
        <Route path="/gst" element={<Gst />} />
        <Route path="/itr" element={<ITR />} />
        <Route path="/MutualFundcalculator" element={<MutualFundcalculator />} />
        <Route path="/Blog" element={<Blog />} />
        <Route path="/BlogDetails" element={<BlogDetails />} />
        <Route path="/respons" element={<PaymentResponse/>} />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/service" element={<ServiceHomepage/>} />
       
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        newestOnTop={false}
        closeOnClick
        theme="colored"
      />
      <GoToTop />
    </>
  );
}
export default App;
